import * as React from "react"
import {Buffer} from 'buffer';

// p0 <-- stringToColour(contract_addrr)
// p1 <-- complement(p0)
// p2 <-- stringToColour(expiry)
// p3 <-- stringToColour(strike)


// https://stackoverflow.com/questions/1664140/js-function-to-calculate-complementary-colour
// p0: fill='#666665' "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjkwJyBoZWlnaHQ9JzUwMCcgdmlld0JveD0nMCAwIDI5MCA1MDAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PHJlY3Qgd2lkdGg9JzI5MHB4JyBoZWlnaHQ9JzUwMHB4JyBmaWxsPScjNjY2NjY1Jy8+PC9zdmc+"
// p1: fill='#4859bd' "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjkwJyBoZWlnaHQ9JzUwMCcgdmlld0JveD0nMCAwIDI5MCA1MDAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PGNpcmNsZSBjeD0nMjA0JyBjeT0nMTg1JyByPScxMjBweCcgZmlsbD0nIzQ4NTliZCcvPjwvc3ZnPg=="
// p2:                "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjkwJyBoZWlnaHQ9JzUwMCcgdmlld0JveD0nMCAwIDI5MCA1MDAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PGNpcmNsZSBjeD0nMTk5JyBjeT0nMzQ1JyByPScxMjBweCcgZmlsbD0nIzA2ZWI0OCcvPjwvc3ZnPg==
// p3:                "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjkwJyBoZWlnaHQ9JzUwMCcgdmlld0JveD0nMCAwIDI5MCA1MDAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PGNpcmNsZSBjeD0nMjQxJyBjeT0nMjcxJyByPScxMDBweCcgZmlsbD0nIzc1NmNjMicvPjwvc3ZnPg=="


// ETH: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjU2cHgiIGhlaWdodD0iNDE3cHgiIHZpZXdCb3g9IjAgMCAyNTYgNDE3IiB2ZXJzaW9uPSIxLjEiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIj4KCTxnPgoJCTxwb2x5Z29uIGZpbGw9IiMzNDM0MzQiIHBvaW50cz0iMTI3Ljk2MTEgMCAxMjUuMTY2MSA5LjUgMTI1LjE2NjEgMjg1LjE2OCAxMjcuOTYxMSAyODcuOTU4IDI1NS45MjMxIDIxMi4zMiIvPgoJCTxwb2x5Z29uIGZpbGw9IiM4QzhDOEMiIHBvaW50cz0iMTI3Ljk2MiAwIDAgMjEyLjMyIDEyNy45NjIgMjg3Ljk1OSAxMjcuOTYyIDE1NC4xNTgiLz4KCQk8cG9seWdvbiBmaWxsPSIjM0MzQzNCIiBwb2ludHM9IjEyNy45NjExIDMxMi4xODY2IDEyNi4zODYxIDMxNC4xMDY2IDEyNi4zODYxIDQxMi4zMDU2IDEyNy45NjExIDQxNi45MDY2IDI1NS45OTkxIDIzNi41ODY2Ii8+CgkJPHBvbHlnb24gZmlsbD0iIzhDOEM4QyIgcG9pbnRzPSIxMjcuOTYyIDQxNi45MDUyIDEyNy45NjIgMzEyLjE4NTIgMCAyMzYuNTg1MiIvPgoJCTxwb2x5Z29uIGZpbGw9IiMxNDE0MTQiIHBvaW50cz0iMTI3Ljk2MTEgMjg3Ljk1NzcgMjU1LjkyMTEgMjEyLjMyMDcgMTI3Ljk2MTEgMTU0LjE1ODciLz4KCQk8cG9seWdvbiBmaWxsPSIjMzkzOTM5IiBwb2ludHM9IjAuMDAwOSAyMTIuMzIwOCAxMjcuOTYwOSAyODcuOTU3OCAxMjcuOTYwOSAxNTQuMTU4OCIvPgoJPC9nPgo8L3N2Zz4="

const SvgComponent = (props) => {

  const cyrb53 = function(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1>>>16), 2246822507) ^ Math.imul(h2 ^ (h2>>>13), 3266489909);
    h2 = Math.imul(h2 ^ (h2>>>16), 2246822507) ^ Math.imul(h1 ^ (h1>>>13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1>>>0);
  };
  
  var stringToColour = function(str) {
    const newStr = cyrb53(str).toString();
    //console.log(newStr);
    var hash = 0;
    for (var i = 0; i < newStr.length; i++) {
      hash = newStr.charCodeAt(i) + ((hash << 5) - hash);
    }
    var colour = '#';
    for (var i = 0; i < 3; i++) {
      var value = (hash >> (i * 8)) & 0xFF;
      colour += ('00' + value.toString(16)).substr(-2);
    }
    return colour;
  }
  
  function padZero(str, len) {
    len = len || 2;
    var zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  }
  
  function invertColor(hex, bw) {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
        // https://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
            ? '#000000'
            : '#FFFFFF';
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    return "#" + padZero(r) + padZero(g) + padZero(b);
  }
  
  function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    //console.log(color)
    return color;
  }
  
  
  function p0(col){ //'#666665';
    let img = `<svg width='290' height='500' viewBox='0 0 290 500' xmlns='http://www.w3.org/2000/svg'><rect width='290px' height='500px' fill='${col}'/></svg>`;
    const encodedString = Buffer.from(img).toString('base64');
    return("data:image/svg+xml;base64," + encodedString)
  }
  
  function p1(col){ //'#756cc2';
    let img = `<svg width='290' height='500' viewBox='0 0 290 500' xmlns='http://www.w3.org/2000/svg'><circle cx='204' cy='185' r='120px' fill='${col}'/></svg>`;
    const encodedString = Buffer.from(img).toString('base64');
    return("data:image/svg+xml;base64," + encodedString)
  }
  
  function p2(){ //'#06eb48';
    let img = `<svg width='290' height='500' viewBox='0 0 290 500' xmlns='http://www.w3.org/2000/svg'><circle cx='199' cy='345' r='120px' fill='${getRandomColor()}'/></svg>`;
    const encodedString = Buffer.from(img).toString('base64');
    return("data:image/svg+xml;base64," + encodedString)
  }
  
  function p3(){ //'#756cc2';
    let img = `<svg width='290' height='500' viewBox='0 0 290 500' xmlns='http://www.w3.org/2000/svg'><circle cx='241' cy='271' r='100px' fill='${getRandomColor()}'/></svg>`;
    const encodedString = Buffer.from(img).toString('base64');
    return("data:image/svg+xml;base64," + encodedString)
  }
  
  
  const p0col = stringToColour(props.contract);
  const p1col = invertColor(p0col, false);
  const xlinkRef0 = p0(p0col);
  const xlinkRef1 = p1(p1col);
  //console.log(`Color for contract ${props.contract}: ${p0col} : ${p1col}`)
  return(
  <svg
    width={215}
    height={370}
    viewBox="0 0 290 500"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <linearGradient id="a" x1={1} x2={0} y1={1} y2={0}>
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="b" x1={0} x2={1} y1={0} y2={1}>
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="c">
        <stop offset={0.7} stopColor="#fff" />
        <stop offset={0.95} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <filter id="e">
        <feImage
          result="p0"
          xlinkHref={xlinkRef0}
        />
        <feImage
          result="p1"
          xlinkHref={xlinkRef1}
        />
        <feImage
          result="p2"
          xlinkHref={p2()}
        />
        <feImage
          result="p3"
          xlinkHref={p3()}
        />
        <feBlend mode="overlay" in="p0" in2="p1" />
        <feBlend mode="exclusion" in2="p2" />
        <feBlend mode="overlay" in2="p3" result="blendOut" />
        <feGaussianBlur in="blendOut" stdDeviation={42} />
      </filter>
      <filter id="f">
        <feGaussianBlur in="SourceGraphic" stdDeviation={24} />
      </filter>
      <clipPath id="d">
        <rect width={290} height={500} rx={42} ry={42} />
      </clipPath>
      <path
        id="g"
        d="M40 12h210a28 28 0 0 1 28 28v420a28 28 0 0 1-28 28H40a28 28 0 0 1-28-28V40a28 28 0 0 1 28-28z"
      />
      <mask id="h" maskContentUnits="userSpaceOnUse">
        <path fill="url(#c)" d="M0 0h290v200H0z" />
      </mask>
    </defs>
    <g clipPath="url(#d)">
      <path fill="a0b869" d="M0 0h290v500H0z" />
      <path
        style={{
          filter: "url(#e)",
        }}
        d="M0 0h290v500H0z"
      />
      <g
        style={{
          filter: "url(#f)",
          transform: "scale(1.5)",
          transformOrigin: "center top",
        }}
      >
        <path fill="none" d="M0 0h290v500H0z" />
        <ellipse cx="50%" rx={180} ry={120} opacity={0.85} />
      </g>
      <rect
        width={290}
        height={500}
        rx={42}
        ry={42}
        fill="rgba(0,0,0,0)"
        stroke="rgba(255,255,255,0.2)"
      />

      <g id="SvgjsG1017" transform="matrix(1.64313 0 0 1.64313 17.479 -12.16) scale(5.5) translate(0,-8)">
            <path
              id="path6"
              d="M8.2 48.3c-1 0-1.5-.9-1.5-1.5v-6.2c0-.8.3-1.3 1-1.8L22 30.6l-2.7-1.5-10.5 6c-.2.1-.5.2-.8.2-.8 0-1.5-.7-1.5-1.5 0-.6.3-1 .8-1.3l10.9-6.3c.4-.2.7-.3 1-.3s.7.1 1 .3l5.3 3.1c.6.3.7.9.7 1.3 0 .5-.3 1-.7 1.3L9.6 41.2v3.1l14.7-8.5c.2-.1.5-.2.8-.2.8 0 1.5.7 1.5 1.5 0 .6-.3 1-.8 1.3L8.9 48.1c-.2.1-.5.2-.7.2zM2.5 58c-1 0-1.5-.9-1.5-1.5v-13c0-.8.7-1.5 1.5-1.5s1.5.8 1.5 1.6V54l20.2-11.7c.6-.3 1.2-.2 1.5 0 .6.3.7.9.7 1.3v6.2c0 .8-.3 1.3-1 1.7l-10.9 6.3c-.2.2-.5.2-.7.2-.8 0-1.5-.7-1.5-1.5 0-.6.3-1 .8-1.3l10.5-6v-3.1L3.3 57.8c-.2.2-.5.2-.8.2zm.1-25.9c-1 0-1.5-.9-1.5-1.5v-6.2c0-.8.3-1.3 1-1.8L13 16.4c.2-.1.5-.2.8-.2.8 0 1.5.7 1.5 1.5 0 .6-.3 1-.8 1.3L4 25v3.1l14.3-8.3c.4-.2.7-.3 1-.3.3 0 .7.1 1 .3l5.3 3.1c.5.3.8.7.8 1.3 0 .8-.7 1.5-1.5 1.5-.3 0-.5-.1-.8-.2l-4.8-2.8-16 9.2c-.2.1-.5.2-.7.2z"
              style={{
                fill: "#f6f6f6",
                opacity: "0.1",
              }}
            />
        </g>
        
    </g>
    
    <text textRendering="optimizeSpeed">
      <textPath
        startOffset="-100%"
        fill="#fff"
        fontFamily="'Roboto', sans-serif"
        fontSize={10}
        xlinkHref="#g"
      >
        {"ztrike.io \u2022 ERC721 Options "}
        <animate
          additive="sum"
          attributeName="startOffset"
          from="0%"
          to="100%"
          begin="0s"
          dur="30s"
          repeatCount="indefinite"
        />
      </textPath>
      <textPath
        startOffset="0%"
        fill="#fff"
        fontFamily="'Roboto', sans-serif"
        fontSize={10}
        xlinkHref="#g"
      >
        {"\r\n    ztrike.io \u2022 ERC721 Options \u2022 V1\r\n    "}
        <animate
          additive="sum"
          attributeName="startOffset"
          from="0%"
          to="100%"
          begin="0s"
          dur="30s"
          repeatCount="indefinite"
        />
      </textPath>
      <textPath
        startOffset="50%"
        fill="#fff"
        fontFamily="'Roboto', sans-serif"
        fontSize={10}
        xlinkHref="#g"
      >
        {
          `Writer: ${props.writer} \u2022 Contract: ${props.contract.substring(0,6) + '..' + props.contract.substring(36,100) } \u2022\r\n        Strike: ${props.strike} \u2022  Expiry: ${props.expiry}`
        }
        <animate
          additive="sum"
          attributeName="startOffset"
          from="0%"
          to="100%"
          begin="0s"
          dur="30s"
          repeatCount="indefinite"
        />
      </textPath>
      <textPath
        startOffset="-50%"
        fill="#fff"
        fontFamily="'Roboto', sans-serif"
        fontSize={10}
        xlinkHref="#g"
      >
        {
          `Writer: ${props.writer} \u2022 Contract: ${props.contract.substring(0,6) + '..' + props.contract.substring(36,100) } \u2022\r\n        Strike: ${props.strike} \u2022  Expiry: ${props.expiry}`
        }
        <animate
          additive="sum"
          attributeName="startOffset"
          from="0%"
          to="100%"
          begin="0s"
          dur="30s"
          repeatCount="indefinite"
        />
      </textPath>
    </text>
    <g mask="url(#h)">
      <path fill="none" d="M0 0h290v200H0z" />
      <text
        y={55}
        x={32}
        fill="#fff"
        fontFamily="'Roboto', sans-serif"
        fontWeight={200}
        fontSize={16}
      >
        Underlying ERC721 token
      </text>
      <text
        y={87}
        x={32}
        fill="#fff"
        fontFamily="'Roboto', sans-serif"
        fontWeight={200}
        fontSize={24}
      >
        {props.contract.substring(0,6) + '..' + props.contract.substring(36,100) }
      </text>
      <text
        y={125}
        x={32}
        fill="#fff"
        fontFamily="'Roboto', sans-serif"
        fontWeight={200}
        fontSize={24}
      >
        {props.type=="Put" ? 'Any ID':`ID # ${props.nftId}`}
      </text>
    </g>
    <rect
      x={16}
      y={16}
      width={258}
      height={468}
      rx={26}
      ry={26}
      fill="rgba(0,0,0,0)"
      stroke="rgba(255,255,255,0.2)"
    />
    <g
      style={{
        transform: "translate(29px,384px)",
      }}
    >
      <rect width={155} height={26} rx={8} ry={8} fill="rgba(0,0,0,0.6)" />
      <text
        x={12}
        y={17}
        fontFamily="'Roboto', sans-serif"
        fontSize={20}
        fill="#fff"
      >
        <tspan xmlSpace="preserve" fill="rgba(255,255,255,0.6)">{"Strike:      "}</tspan>
        {props.strike}
      </text>
    </g>
    <g
      style={{
        transform: "translate(29px,414px)",
      }}
    >
      <rect width={199} height={26} rx={8} ry={8} fill="rgba(0,0,0,0.6)" />
      <text
        x={12}
        y={17}
        fontFamily="'Roboto', sans-serif"
        fontSize={20}
        fill="#fff"
      >
        <tspan fill="rgba(255,255,255,0.6)">{"Expiry: "}</tspan>
        {props.expiry}
      </text>
    </g>
    <g
      style={{
        transform: "translate(29px,444px)",
      }}
    >
      <rect width={140} height={26} rx={8} ry={8} fill="rgba(0,0,0,0.6)" />
      <text
        x={12}
        y={17}
        fontFamily="'Roboto', sans-serif"
        fontSize={20}
        fill="#fff"
      >
        <tspan fill="rgba(255,255,255,0.6)">{"Type: "}</tspan>
        {props.type}
      </text>
    </g>
    <image
      height={350}
      y={100}
      x={-70}
      transform={props.type === "Call" ? "scale(1,1)" :  "translate(290, 0) scale(-1,1)"}
      href="data:image/svg+xml;base64,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"
    />
    <a y="150px" x="32px"  href={`https://opensea.io/assets/ethereum/${props.contract}/${props.nftId}`} target='_top'>
      <image
        height={30}
        y={150}
        x={32}
        xlinkHref="data:image/svg+xml;base64,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"
      />
    </a>
    <a  y="150px" x="75px"  href={`https://etherscan.io/address/${props.contract}`} target='_top'>
      <image
        height={30}
        y={150}
        x={75}
        xlinkHref="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOTMuNzc1IiBoZWlnaHQ9IjI5My42NzEiIHZpZXdCb3g9IjAgMCAyOTMuNzc1IDI5My42NzEiPg0KICA8ZyBpZD0iZXRoZXJzY2FuLWxvZ28tY2lyY2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjE5LjM3OCAtMjEzLjMzKSI+DQogICAgPHBhdGggaWQ9IlBhdGhfMSIgZGF0YS1uYW1lPSJQYXRoIDEiIGQ9Ik0yODAuNDMzLDM1My4xNTJBMTIuNDUsMTIuNDUsMCwwLDEsMjkyLjk0MSwzNDAuN2wyMC43MzcuMDY4YTEyLjQ2NywxMi40NjcsMCwwLDEsMTIuNDY3LDEyLjQ2N3Y3OC40MTRjMi4zMzYtLjY5Miw1LjMzMi0xLjQzLDguNjE0LTIuMmExMC4zODksMTAuMzg5LDAsMCwwLDguMDA5LTEwLjExVjMyMi4wNzNhMTIuNDY5LDEyLjQ2OSwwLDAsMSwxMi40NjgtMTIuNDdoMjAuNzc4YTEyLjQ2OSwxMi40NjksMCwwLDEsMTIuNDY3LDEyLjQ2N3Y5MC4yNzlzNS4yLTIuMTA2LDEwLjI2OS00LjI0NWExMC40MDgsMTAuNDA4LDAsMCwwLDYuMzUzLTkuNTc3VjI5MC45YTEyLjQ2NiwxMi40NjYsMCwwLDEsMTIuNDY2LTEyLjQ2N2gyMC43NzhBMTIuNDY4LDEyLjQ2OCwwLDAsMSw0NTAuODE1LDI5MC45djg4LjYyNWMxOC4wMTQtMTMuMDU1LDM2LjI3MS0yOC43NTgsNTAuNzU5LTQ3LjYzOWEyMC45MjYsMjAuOTI2LDAsMCwwLDMuMTg1LTE5LjUzNywxNDYuNiwxNDYuNiwwLDAsMC0xMzYuNjQ0LTk5LjAwNmMtODEuNDM5LTEuMDk0LTE0OC43NDQsNjUuMzg1LTE0OC43MzYsMTQ2LjgzNGExNDYuMzcxLDE0Ni4zNzEsMCwwLDAsMTkuNSw3My40NSwxOC41NiwxOC41NiwwLDAsMCwxNy43MDcsOS4xNzNjMy45MzEtLjM0Niw4LjgyNS0uODM1LDE0LjY0My0xLjUxOGExMC4zODMsMTAuMzgzLDAsMCwwLDkuMjA5LTEwLjMwNlYzNTMuMTUyIiBmaWxsPSIjMjEzMjViIi8+DQogICAgPHBhdGggaWQ9IlBhdGhfMiIgZGF0YS1uYW1lPSJQYXRoIDIiIGQ9Ik0yNDQuNDE3LDM5OC42NDFBMTQ2LjgwOCwxNDYuODA4LDAsMCwwLDQ3Ny41ODksMjc5LjljMC0zLjM4MS0uMTU3LTYuNzI0LS4zODMtMTAuMDQ5LTUzLjY0Miw4MC0xNTIuNjg2LDExNy40LTIzMi43OSwxMjguNzkzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNS41NjQgODAuMjY5KSIgZmlsbD0iIzk3OTY5NSIvPg0KICA8L2c+DQo8L3N2Zz4NCg=="
      />
    </a>

    <a  y="385px" x="110px"  href={"https://ztrike.io/app"} target='_top'>
    <image
        height={20}
        y={385}
        x={110}
        xlinkHref="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjU2cHgiIGhlaWdodD0iNDE3cHgiIHZpZXdCb3g9IjAgMCAyNTYgNDE3IiB2ZXJzaW9uPSIxLjEiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIj4KCTxnPgoJCTxwb2x5Z29uIGZpbGw9IiMzNDM0MzQiIHBvaW50cz0iMTI3Ljk2MTEgMCAxMjUuMTY2MSA5LjUgMTI1LjE2NjEgMjg1LjE2OCAxMjcuOTYxMSAyODcuOTU4IDI1NS45MjMxIDIxMi4zMiIvPgoJCTxwb2x5Z29uIGZpbGw9IiM4QzhDOEMiIHBvaW50cz0iMTI3Ljk2MiAwIDAgMjEyLjMyIDEyNy45NjIgMjg3Ljk1OSAxMjcuOTYyIDE1NC4xNTgiLz4KCQk8cG9seWdvbiBmaWxsPSIjM0MzQzNCIiBwb2ludHM9IjEyNy45NjExIDMxMi4xODY2IDEyNi4zODYxIDMxNC4xMDY2IDEyNi4zODYxIDQxMi4zMDU2IDEyNy45NjExIDQxNi45MDY2IDI1NS45OTkxIDIzNi41ODY2Ii8+CgkJPHBvbHlnb24gZmlsbD0iIzhDOEM4QyIgcG9pbnRzPSIxMjcuOTYyIDQxNi45MDUyIDEyNy45NjIgMzEyLjE4NTIgMCAyMzYuNTg1MiIvPgoJCTxwb2x5Z29uIGZpbGw9IiMxNDE0MTQiIHBvaW50cz0iMTI3Ljk2MTEgMjg3Ljk1NzcgMjU1LjkyMTEgMjEyLjMyMDcgMTI3Ljk2MTEgMTU0LjE1ODciLz4KCQk8cG9seWdvbiBmaWxsPSIjMzkzOTM5IiBwb2ludHM9IjAuMDAwOSAyMTIuMzIwOCAxMjcuOTYwOSAyODcuOTU3OCAxMjcuOTYwOSAxNTQuMTU4OCIvPgoJPC9nPgo8L3N2Zz4="
        />
      </a>
      <a  y="20px" x="270px" href={"https://ztrike.io/app"} target='_top'>
      <g id="SvgjsG1019" transform="matrix(1.64313 0 0 1.64313 17.479 -12.16) scale(0.7) translate(20,270)">
            <path
              id="path6"
              d="M8.2 48.3c-1 0-1.5-.9-1.5-1.5v-6.2c0-.8.3-1.3 1-1.8L22 30.6l-2.7-1.5-10.5 6c-.2.1-.5.2-.8.2-.8 0-1.5-.7-1.5-1.5 0-.6.3-1 .8-1.3l10.9-6.3c.4-.2.7-.3 1-.3s.7.1 1 .3l5.3 3.1c.6.3.7.9.7 1.3 0 .5-.3 1-.7 1.3L9.6 41.2v3.1l14.7-8.5c.2-.1.5-.2.8-.2.8 0 1.5.7 1.5 1.5 0 .6-.3 1-.8 1.3L8.9 48.1c-.2.1-.5.2-.7.2zM2.5 58c-1 0-1.5-.9-1.5-1.5v-13c0-.8.7-1.5 1.5-1.5s1.5.8 1.5 1.6V54l20.2-11.7c.6-.3 1.2-.2 1.5 0 .6.3.7.9.7 1.3v6.2c0 .8-.3 1.3-1 1.7l-10.9 6.3c-.2.2-.5.2-.7.2-.8 0-1.5-.7-1.5-1.5 0-.6.3-1 .8-1.3l10.5-6v-3.1L3.3 57.8c-.2.2-.5.2-.8.2zm.1-25.9c-1 0-1.5-.9-1.5-1.5v-6.2c0-.8.3-1.3 1-1.8L13 16.4c.2-.1.5-.2.8-.2.8 0 1.5.7 1.5 1.5 0 .6-.3 1-.8 1.3L4 25v3.1l14.3-8.3c.4-.2.7-.3 1-.3.3 0 .7.1 1 .3l5.3 3.1c.5.3.8.7.8 1.3 0 .8-.7 1.5-1.5 1.5-.3 0-.5-.1-.8-.2l-4.8-2.8-16 9.2c-.2.1-.5.2-.7.2z"
              style={{
                fill: "#f6f6f6",
                opacity: "0.8",
              }}
            />
            </g>
      </a>
  </svg>
)};

export default SvgComponent
